import './Title.css'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useThemeContext } from '../../../../../contexts'

export const Title: React.FC = () => {
  const { t } = useTranslation()
  const { theme } = useThemeContext()
  const isEnabled = theme?.Title?.IsEnabled && theme?.IsEnabled
  const title = theme?.Title?.Value

  return (
    <Link
      to="/"
      className="header__title font-bold no-underline hidden md:inline"
    >
      {isEnabled && title ? title : t('common.app.title')}
    </Link>
  )
}
